module.exports = "../../../../platform/assets/pageMainIcon/simple_baobiaochaxunlei8.svg";